// Main configuration exports
export { projectInformationCardsConfig } from './project-information-cards-config';

// List and card configurations
export { copiedProjectsListGridConfig } from './list-grid-config';
export { copiedProjectsCardConfig } from './card-list-config';

// Button configurations
export { addModuleActionButton, modalCloseButtonIcon } from './button-configs';

// Title and navigation configurations
export {
  projectModuleTitle,
  projectModuleOptiontitle
} from './title-configs';

// Utility functions
export { buildProjectCards, buildProjectCard, buildNoModulesCard } from './card-item-builder';
export type { CardItemOptions } from './card-item-builder';

// Formatting functions
export {
  formatCopiedProjectsForDisplay,
  formatCategories,
  formatDate,
  formatDescription
} from './formatters';
